var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Testimonials_2",
    "data-name": "Testimonials 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1187.4 362.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Testimonials-1, .Testimonials-2 {\n        font-family: MyriadPro-Regular, 'MyriadPro-Regular';\n      }\n\n      .Testimonials-1, .Testimonials-3 {\n        fill: #f0e2cb;\n      }\n\n      .Testimonials-4 {\n        fill: #e42a3b;\n      }\n\n      .Testimonials-5, .Testimonials-6 {\n        fill: #ee3337;\n      }\n\n      .Testimonials-7 {\n        font-size: 18px;\n      }\n\n      .Testimonials-6, .Testimonials-8 {\n        font-family: RedSoxNationNormal, 'RedSoxNation';\n      }\n\n      .Testimonials-3, .Testimonials-9 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-10 {\n        letter-spacing: -.03em;\n      }\n\n      .Testimonials-11 {\n        letter-spacing: 0em;\n      }\n\n      .Testimonials-12 {\n        letter-spacing: .07em;\n      }\n\n      .Testimonials-13 {\n        letter-spacing: .06em;\n      }\n\n      .Testimonials-14 {\n        letter-spacing: .07em;\n      }\n\n      .Testimonials-15 {\n        letter-spacing: .07em;\n      }\n\n      .Testimonials-16 {\n        letter-spacing: .06em;\n      }\n\n      .Testimonials-17 {\n        letter-spacing: .06em;\n      }\n\n      .Testimonials-18 {\n        letter-spacing: .06em;\n      }\n\n      .Testimonials-19 {\n        letter-spacing: .01em;\n      }\n\n      .Testimonials-20 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-21 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-22 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-23 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-24 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-25 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-26 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-27 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-28 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-29 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-30 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-31 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-32 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-33 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-34 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-35 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-36 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-37 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-38 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-39 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-40 {\n        letter-spacing: .05em;\n      }\n\n      .Testimonials-41 {\n        letter-spacing: .03em;\n      }\n\n      .Testimonials-42 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-43 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-44 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-45 {\n        letter-spacing: .04em;\n      }\n\n      .Testimonials-46 {\n        letter-spacing: 0em;\n      }\n\n      .Testimonials-47 {\n        letter-spacing: 0em;\n      }\n\n      .Testimonials-48 {\n        letter-spacing: .01em;\n      }\n\n      .Testimonials-49 {\n        letter-spacing: .01em;\n      }\n\n      .Testimonials-50 {\n        letter-spacing: 0em;\n      }\n\n      .Testimonials-51 {\n        letter-spacing: 0em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Testimonials_1",
    "data-name": "Testimonials 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M217.75,55.78c.53-12.4,1.05-24.8,1.58-37.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M326.99,97.51c7.2-3.77,12.71-9.9,19.33-14.55,9.67-6.77,22.08-10.71,28.64-20.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M108.81,5.73c5.98,7.3,9.04,16.35,13.65,24.5,3.61,6.39,8.18,12.23,12.74,18.05,2.98,3.81,9.49,16.52,10.87,23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M287.38,65.23c1.19-5.11,2.38-10.22,3.58-15.33,1.75-7.51,3.52-15.07,6.79-22.11,3.75-8.08,9.48-15.53,10.92-24.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M110.54,82.11c-10.02-17.35-36.43-36.9-49.21-52.49-4.19-5.12-20.51-18.88-26.29-22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M182.63,60.08c-1.03-11.28-4.35-22.37-9.74-32.45-1.47-2.76-3.11-5.45-4.21-8.36-1.98-5.21-2.19-10.93-4.29-16.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M253.11,59.94c1.34-8.03,2.68-16.09,5.28-23.83,3.56-10.6,9.47-20.59,10.95-31.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M308.11,77.01c10.67-16.82,23.96-31.96,37.19-47.02,6.84-7.78,13.68-15.57,20.52-23.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M272.21,59.72c2.04-11.3,13.01-31.39,12.49-42.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M320.97,82.4c5.77-8.78,16.49-12.23,22.91-20.46,3.13-4.02,5.1-9.03,8.6-12.67,1.74-1.82,3.8-3.23,5.85-4.62,3.98-2.72,38.35-36.19,42.33-38.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M298.22,69.67c4.53-13.72,16.51-23.86,21.56-37.4.72-1.92,1.29-3.91,2.24-5.72,2.56-4.87,7.64-8.14,9.72-13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M335.84,9.17c1.99-1.87,3.86-3.88,5.59-6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M183.79,0c1.65,3.09,2.74,6.42,3.83,9.74,1.15,3.52,2.3,7.03,3.46,10.55,1.77,5.42,3.56,10.91,3.88,16.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M196.96,46.39c-.31-.56-.63-1.12-.94-1.67.91,2.99,1.81,5.98,2.72,8.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M136.61,7.43c7.47,8.53,9.02,20.52,15.49,29.76,1.53,2.18,3.36,4.27,4.05,6.81.67,2.43.22,5.05.91,7.48,1.32,4.6,6.43,7.55,7.59,12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M72.79,4.98c4.65,2,19.39,22.11,22.28,26.13,4.1,5.68,7.91,11.54,11.41,17.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M110.61,54.38c2.38,3.13,4.75,6.27,7.13,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M236.65,58.16c1.77-14.79,3.89-29.53,6.36-44.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M4.96,115.58c7.76-.9,14.74,4.02,21.96,6.89,11.12,4.41,38.25,10.35,49.44,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M0,176.06c9.87-1.46,10.03-2.33,20.15-1.79,6.43.34,12.8,1.39,19.22,1.7,10.12.48,20.32-.91,29.9-4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M341.47,174.54c12.85.61,16.66.38,27.85-2.69,11.19-3.08,22.2-6.99,33.72-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M340.31,136.13c10.51-7.39,17.65-9.45,43.8-22.65,6.6-3.33,14.63-5.4,18.17-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M337.99,114.76c3.17-2.4,6.3-4.85,9.41-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M352.47,102.68c6.1-3.47,12.21-6.94,18.31-10.41,3.25-1.85,6.51-3.7,9.66-5.7,6.39-4.04,12.38-8.67,17.84-13.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M338,157.53c3.79.72,7.73.73,11.52.03,4.1-.76,8.38-2.32,12.29-.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M367.25,153.69c11.13-3.46,22.26-6.93,33.4-10.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M71.46,156.43c-5.07-2.63-18.82-4.33-24.45-5-6.91-.83-14.1-.14-20.65-2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M16.8,143.44c-4.57-1.35-9.24-2.34-13.96-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M4.96,83.51c3.14,1.35,20.3,8.39,23.45,9.74,2.18.93,4.37,1.87,6.69,2.37,1.86.4,3.78.52,5.66.88,4.36.84,8.43,3.01,11.46,6.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M83.31,117.72c-4.09-.79-22.22-8.97-25.82-10.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M60.72,60.8c7.45,5.19,14.91,10.38,22.36,15.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M3.2,13.06c4.41,4.32,47.29,39.83,52.4,43.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M379.42,56.13c5.23-3.61,9.49-8.32,13.7-13,1.88-2.08,3.75-4.16,5.63-6.25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1002.11,55.78c.53-12.4,1.05-24.8,1.58-37.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1111.35,97.51c7.2-3.77,12.71-9.9,19.33-14.55,9.67-6.77,22.08-10.71,28.64-20.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M792.38,52.54c5.63,4.47,34.58,23.04,41.45,25.41,6.12,2.11,36.99,22.74,44.48,24.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M893.18,5.73c5.98,7.3,9.04,16.35,13.65,24.5,3.61,6.39,8.18,12.23,12.74,18.05,2.98,3.81,9.49,16.52,10.87,23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1071.74,65.23c1.19-5.11,2.38-10.22,3.58-15.33,1.75-7.51,3.52-15.07,6.79-22.11,3.75-8.08,9.48-15.53,10.92-24.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M894.9,82.11c-10.02-17.35-36.43-36.9-49.21-52.49-4.19-5.12-20.51-18.88-26.29-22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M966.99,60.08c-1.03-11.28-4.35-22.37-9.74-32.45-1.47-2.76-3.11-5.45-4.21-8.36-1.98-5.21-2.19-10.93-4.29-16.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1037.47,59.94c1.34-8.03,2.68-16.09,5.28-23.83,3.56-10.6,9.47-20.59,10.95-31.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1092.47,77.01c10.67-16.82,23.96-31.96,37.19-47.02,6.84-7.78,13.68-15.57,20.52-23.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1056.57,59.72c2.04-11.3,13.01-31.39,12.49-42.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1105.33,82.4c5.77-8.78,16.49-12.23,22.91-20.46,3.13-4.02,5.1-9.03,8.6-12.67,1.74-1.82,3.8-3.23,5.85-4.62,3.98-2.72,38.35-36.19,42.33-38.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1082.58,69.67c4.53-13.72,16.51-23.86,21.56-37.4.72-1.92,1.29-3.91,2.24-5.72,2.56-4.87,7.64-8.14,9.72-13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1120.2,9.17c1.99-1.87,3.86-3.88,5.59-6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M968.15,0c1.65,3.09,2.74,6.42,3.83,9.74,1.15,3.52,2.3,7.03,3.46,10.55,1.77,5.42,3.56,10.91,3.88,16.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M981.32,46.39c-.31-.56-.63-1.12-.94-1.67.91,2.99,1.81,5.98,2.72,8.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M920.97,7.43c7.47,8.53,9.02,20.52,15.49,29.76,1.53,2.18,3.36,4.27,4.05,6.81.67,2.43.22,5.05.91,7.48,1.32,4.6,6.43,7.55,7.59,12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M857.15,4.98c4.65,2,19.39,22.11,22.28,26.13,4.1,5.68,7.91,11.54,11.41,17.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M894.97,54.38c2.38,3.13,4.75,6.27,7.13,9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1021.01,58.16c1.77-14.79,3.89-29.53,6.36-44.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M789.32,115.58c7.76-.9,14.74,4.02,21.96,6.89,11.12,4.41,38.25,10.35,49.44,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M784.36,176.06c9.87-1.46,10.03-2.33,20.15-1.79,6.43.34,12.8,1.39,19.22,1.7,10.12.48,20.32-.91,29.9-4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1125.83,174.54c12.85.61,16.66.38,27.85-2.69,11.19-3.08,22.2-6.99,33.72-8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1124.67,136.13c10.51-7.39,17.65-9.45,43.8-22.65,6.6-3.33,14.63-5.4,18.17-11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1122.36,114.76c3.17-2.4,6.3-4.85,9.41-7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1136.83,102.68c6.1-3.47,12.21-6.94,18.31-10.41,3.25-1.85,6.51-3.7,9.66-5.7,6.39-4.04,12.38-8.67,17.84-13.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1122.37,157.53c3.79.72,7.73.73,11.52.03,4.1-.76,8.38-2.32,12.29-.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1151.61,153.69c11.13-3.46,22.26-6.93,33.4-10.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M855.82,156.43c-5.07-2.63-18.82-4.33-24.45-5-6.91-.83-14.1-.14-20.65-2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M801.16,143.44c-4.57-1.35-9.24-2.34-13.96-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M789.32,83.51c3.14,1.35,20.3,8.39,23.45,9.74,2.18.93,4.37,1.87,6.69,2.37,1.86.4,3.78.52,5.66.88,4.36.84,8.43,3.01,11.46,6.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M867.67,117.72c-4.09-.79-22.22-8.97-25.82-10.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M845.09,60.8c7.45,5.19,14.91,10.38,22.36,15.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M787.56,13.06c4.41,4.32,47.29,39.83,52.4,43.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M1163.78,56.13c5.23-3.61,9.49-8.32,13.7-13,1.88-2.08,3.75-4.16,5.63-6.25"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M569.92,307.15c-.53,12.4-1.05,24.8-1.58,37.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M460.67,265.42c-7.2,3.77-12.71,9.9-19.33,14.55-9.67,6.77-22.08,10.71-28.64,20.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M779.64,310.39c-5.63-4.47-34.58-23.04-41.45-25.41-6.12-2.11-36.99-22.74-44.48-24.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M678.85,357.2c-5.98-7.3-9.04-16.35-13.65-24.5-3.61-6.39-8.18-12.23-12.74-18.05-2.98-3.81-9.49-16.52-10.87-23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M500.29,297.7c-1.19,5.11-2.38,10.22-3.58,15.33-1.75,7.51-3.52,15.07-6.79,22.11-3.75,8.08-9.48,15.53-10.92,24.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M677.12,280.82c10.02,17.35,36.43,36.9,49.21,52.49,4.19,5.12,20.51,18.88,26.29,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M605.03,302.85c1.03,11.28,4.35,22.37,9.74,32.45,1.47,2.76,3.11,5.45,4.21,8.36,1.98,5.21,2.19,10.93,4.29,16.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M534.56,302.99c-1.34,8.03-2.68,16.09-5.28,23.83-3.56,10.6-9.47,20.59-10.95,31.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M479.56,285.92c-10.67,16.82-23.96,31.96-37.19,47.02-6.84,7.78-13.68,15.57-20.52,23.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M515.45,303.22c-2.04,11.3-13.01,31.39-12.49,42.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M466.7,280.53c-5.77,8.78-16.49,12.23-22.91,20.46-3.13,4.02-5.1,9.03-8.6,12.67-1.74,1.82-3.8,3.23-5.85,4.62-3.98,2.72-38.35,36.19-42.33,38.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M489.45,293.26c-4.53,13.72-16.51,23.86-21.56,37.4-.72,1.92-1.29,3.91-2.24,5.72-2.56,4.87-7.64,8.14-9.72,13.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M451.82,353.77c-1.99,1.87-3.86,3.88-5.59,6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M603.87,362.93c-1.65-3.09-2.74-6.42-3.83-9.74-1.15-3.52-2.3-7.03-3.46-10.55-1.77-5.42-3.56-10.91-3.88-16.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M590.71,316.54c.31.56.63,1.12.94,1.67-.91-2.99-1.81-5.98-2.72-8.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M651.06,355.5c-7.47-8.53-9.02-20.52-15.49-29.76-1.53-2.18-3.36-4.27-4.05-6.81-.67-2.43-.22-5.05-.91-7.48-1.32-4.6-6.43-7.55-7.59-12.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M714.87,357.95c-4.65-2-19.39-22.11-22.28-26.13-4.1-5.68-7.91-11.54-11.41-17.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M677.05,308.55c-2.38-3.13-4.75-6.27-7.13-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M551.02,304.77c-1.77,14.79-3.89,29.53-6.36,44.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M782.71,247.35c-7.76.9-14.74-4.02-21.96-6.89-11.12-4.41-38.25-10.35-49.44-14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M787.66,186.87c-9.87,1.46-10.03,2.33-20.15,1.79-6.43-.34-12.8-1.39-19.22-1.7-10.12-.48-20.32.91-29.9,4.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M446.2,188.39c-12.85-.61-16.66-.38-27.85,2.69-11.19,3.08-22.2,6.99-33.72,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M447.35,226.8c-10.51,7.39-17.65,9.45-43.8,22.65-6.6,3.33-14.63,5.4-18.17,11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M449.67,248.18c-3.17,2.4-6.3,4.85-9.41,7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M435.2,260.25c-6.1,3.47-12.21,6.94-18.31,10.41-3.25,1.85-6.51,3.7-9.66,5.7-6.39,4.04-12.38,8.67-17.84,13.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M449.66,205.4c-3.79-.72-7.73-.73-11.52-.03-4.1.76-8.38,2.32-12.29.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M420.42,209.24c-11.13,3.46-22.26,6.93-33.4,10.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M716.21,206.5c5.07,2.63,18.82,4.33,24.45,5,6.91.83,14.1.14,20.65,2.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M770.87,219.5c4.57,1.35,9.24,2.34,13.96,2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M782.71,279.42c-3.14-1.35-20.3-8.39-23.45-9.74-2.18-.93-4.37-1.87-6.69-2.37-1.86-.4-3.78-.52-5.66-.88-4.36-.84-8.43-3.01-11.46-6.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M704.35,245.21c4.09.79,22.22,8.97,25.82,10.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M726.94,302.13c-7.45-5.19-14.91-10.38-22.36-15.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M784.47,349.87c-4.41-4.32-47.29-39.83-52.4-43.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "Testimonials-4",
    d: "M408.25,306.8c-5.23,3.61-9.49,8.32-13.7,13-1.88,2.08-3.75,4.16-5.63,6.25"
  })), /*#__PURE__*/React.createElement("text", {
    className: "Testimonials-7",
    transform: "translate(132.97 141.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-18",
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 5.38,
    y: 0
  }, "f "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-33",
    x: 16.25,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 25.45,
    y: 0
  }, "ou"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-15",
    x: 47.05,
    y: 0
  }, "'"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-34",
    x: 51.71,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 61.09,
    y: 0
  }, "e ne"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-34",
    x: 96.53,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 105.91,
    y: 0
  }, "er had ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: -14.68,
    y: 21.6
  }, "quesobi"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-25",
    x: 52.15,
    y: 21.6
  }, "rr"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 65.87,
    y: 21.6
  }, "ia ta"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-39",
    x: 101.71,
    y: 21.6
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 110.56,
    y: 21.6
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-45",
    x: 121.34,
    y: 21.6
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 129.18,
    y: 21.6
  }, ","), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-46",
    x: 133.8,
    y: 21.6
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-19",
    x: 137.69,
    y: 21.6
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 147.68,
    y: 21.6
  }, "OU ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: -14.14,
    y: 43.2
  }, "ARE MISSING OUT! "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-26",
    x: 143.59,
    y: 43.2
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 156.21,
    y: 43.2
  }, "et ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: -12.28,
    y: 64.8
  }, "he"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-34",
    x: 8.53,
    y: 64.8
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 15.14,
    y: 64.8
  }, "e n"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-30",
    x: 40.66,
    y: 64.8
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-48",
    x: 51.32,
    y: 64.8
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-21",
    x: 64.76,
    y: 64.8
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-51",
    x: 69.39,
    y: 64.8
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-31",
    x: 73.37,
    y: 64.8
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 83.09,
    y: 64.8
  }, "he bi"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-25",
    x: 124.86,
    y: 64.8
  }, "rr"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 138.58,
    y: 64.8
  }, "ia is ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: -8.63,
    y: 86.4
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: -1.88,
    y: 86.4
  }, "ende"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-11",
    x: 39.9,
    y: 86.4
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 45.73,
    y: 86.4
  }, ", jui"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-14",
    x: 76.27,
    y: 86.4
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-49",
    x: 85.56,
    y: 86.4
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 94.24,
    y: 86.4
  }, ", and the ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: -14.61,
    y: 108
  }, "se"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-12",
    x: 3.34,
    y: 108
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 10.57,
    y: 108
  }, "vi"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: 25.24,
    y: 108
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 34.1,
    y: 108
  }, "e is outstanding!")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 78.97,
    y: 129.6
  })), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-8",
    x: 43,
    y: 151.2
  }, "Leanna K"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-2",
    x: 111.22,
    y: 151.2
  }, "."))), /*#__PURE__*/React.createElement("text", {
    className: "Testimonials-7",
    transform: "translate(479.91 105.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-29",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 11.21,
    y: 0
  }, "ame he"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-34",
    x: 72.14,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 78.75,
    y: 0
  }, "e a"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-13",
    x: 102.96,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: 109.31,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 116.06,
    y: 0
  }, "er hea"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-25",
    x: 167.87,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 174.72,
    y: 0
  }, "ing ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-27",
    x: 13.95,
    y: 21.6
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 29.63,
    y: 21.6
  }, "y f"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-23",
    x: 49.88,
    y: 21.6
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 56.74,
    y: 21.6
  }, "iend "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-20",
    x: 98.42,
    y: 21.6
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-28",
    x: 105.12,
    y: 21.6
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-34",
    x: 114.55,
    y: 21.6
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 123.93,
    y: 21.6
  }, "e about ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 0.62,
    y: 43.2
  }, "this pla"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-37",
    x: 62.09,
    y: 43.2
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-44",
    x: 70.95,
    y: 43.2
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 80.65,
    y: 43.2
  }, ", and I "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-35",
    x: 136.14,
    y: 43.2
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 150.22,
    y: 43.2
  }, "as not ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 1.14,
    y: 64.8
  }, "disappoi"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-35",
    x: 73.09,
    y: 64.8
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: 83.91,
    y: 64.8
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 90.66,
    y: 64.8
  }, "ed!"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-50",
    x: 116.67,
    y: 64.8
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-29",
    x: 120.64,
    y: 64.8
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 130.36,
    y: 64.8
  }, "he bi"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-25",
    x: 172.14,
    y: 64.8
  }, "rr"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 185.86,
    y: 64.8
  }, "ia ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: -0.17,
    y: 86.4
  }, "is amazin"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-41",
    x: 77.35,
    y: 86.4
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 88.05,
    y: 86.4
  }, ", and the staff ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 31.99,
    y: 108
  }, "is super f"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-25",
    x: 107.41,
    y: 108
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 114.27,
    y: 108
  }, "iendl"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-49",
    x: 156.39,
    y: 108
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 165.07,
    y: 108
  }, ".")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 73.36,
    y: 151.2
  }, "Annie L"))), /*#__PURE__*/React.createElement("text", {
    className: "Testimonials-7",
    transform: "translate(899.85 142.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-29",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 9.72,
    y: 0
  }, "he quali"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-17",
    x: 76.93,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 83.95,
    y: 0
  }, "y of the "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-27",
    x: 152.08,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 158,
    y: 0
  }, "ood ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-36",
    x: 33.52,
    y: 21.6
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 43.03,
    y: 21.6
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-47",
    x: 49.89,
    y: 21.6
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-10",
    x: 53.77,
    y: 21.6
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 63.04,
    y: 21.6
  }, "ona "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-24",
    x: 99.01,
    y: 21.6
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 109.66,
    y: 21.6
  }, "edz is ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: 2.07,
    y: 43.2
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 8.82,
    y: 43.2
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-16",
    x: 19.6,
    y: 43.2
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 31.01,
    y: 43.2
  }, "-no"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-37",
    x: 59.11,
    y: 43.2
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 65.86,
    y: 43.2
  }, "ch."), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-51",
    x: 90.34,
    y: 43.2
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-30",
    x: 94.32,
    y: 43.2
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 104.04,
    y: 43.2
  }, "he tas"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: 154.02,
    y: 43.2
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 160.77,
    y: 43.2
  }, "e is ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-40",
    x: 0.71,
    y: 64.8
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-42",
    x: 10.57,
    y: 64.8
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 19.54,
    y: 64.8
  }, "quisi"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-38",
    x: 59.64,
    y: 64.8
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-44",
    x: 66.39,
    y: 64.8
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 76.09,
    y: 64.8
  }, ", and the staff ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 10.11,
    y: 86.4
  }, "is inc"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-33",
    x: 52.93,
    y: 86.4
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 59.53,
    y: 86.4
  }, "edibly f"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-25",
    x: 122.16,
    y: 86.4
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 129.01,
    y: 86.4
  }, "iendly ")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-1"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 37.43,
    y: 108
  }, "and "), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-36",
    x: 73.66,
    y: 108
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 83.17,
    y: 108
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-37",
    x: 90.03,
    y: 108
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 96.78,
    y: 108
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-35",
    x: 106.69,
    y: 108
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-9",
    x: 117.51,
    y: 108
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-32",
    x: 129.48,
    y: 108
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-43",
    x: 138.86,
    y: 108
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-22",
    x: 148.56,
    y: 108
  }, ".")), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-8",
    x: 59.25,
    y: 151.2
  }, "ROXANA S"), /*#__PURE__*/React.createElement("tspan", {
    className: "Testimonials-2",
    x: 126.74,
    y: 151.2
  }, "."))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonials);
export default __webpack_public_path__ + "static/media/Testimonials.699afcf7da5faedc91095fc9abb1f4d1.svg";
export { ForwardRef as ReactComponent };